<template>
  <section
    class="external-quiz-section"
    :style="{
      '--quiz-panelBgColor': config.panelBgColor,
      '--quiz-outlineColor': config.panelOutlineColor,
      '--quiz-questionColor': config.questionColor,
      '--quiz-questionBgColor': config.questionBgColor,
      '--quiz-optionsColor': config.optionsColor,
      '--quiz-optionsBgColor': config.optionsBgColor,
      '--quiz-pickedColor': config.pickedColor,
      '--quiz-pickedBgColor': config.pickedBgColor,
      '--quiz-btnColor': config.btnColor,
      '--quiz-btnBgColor': config.btnBgColor,
      '--quiz-correctColor': config.correctColor,
      '--quiz-correctBgColor': config.correctBgColor,
      '--quiz-incorrectColor': config.incorrectColor,
      '--quiz-incorrectBgColor': config.incorrectBgColor,
    }">
    <div class="question-container">
      <div class="quiz-question">
        <div class="quiz-question-img-container">
          <img class="quiz-question-img" :src="currentQuestionComputed.question.image" v-if="currentQuestionComputed.question && currentQuestionComputed.question.image" />
        </div>
        <div class="question-text" v-if="currentQuestionComputed.question" v-html="localizedQuestionPrompt"></div>
      </div>
      <div class="quiz-options-and-nav">
        <transition name="fade-fast" mode="out-in">
          <div
            :key="quizKey"
            class="options-container"
            :style="{ flexDirection: currentQuestionComputed.answers.length && currentQuestionComputed.answers[0].image ? 'row' : 'column' }"
            v-if="currentQuestionComputed.answers && currentQuestionComputed.answers.length">
            <label
              :for="currentQuestionComputed.id + index + answer"
              class="option-item"
              :style="{ padding: typeof answer === 'object' && answer.image ? '0' : '0 0 0 16px' }"
              v-for="(answer, index) in currentQuestionComputed.answers"
              :key="currentQuestionComputed.id + index + answer"
              :class="{
                picked:
                  (answers[currentQuestionIndex] && answers[currentQuestionIndex].length && answers[currentQuestionIndex].includes(index)) ||
                  (interacted && interacted[currentQuestionIndex] && interacted[currentQuestionIndex].length && interacted[currentQuestionIndex].includes(index)),
                unpicked: interacted && interacted[currentQuestionIndex] && interacted[currentQuestionIndex].length && !interacted[currentQuestionIndex].includes(index),
              }">
              <div class="option-image-text" :style="{ justifyContent: typeof answer === 'object' && answer.image ? 'center' : 'flex-start' }">
                <div class="option-image" v-if="typeof answer === 'object' && answer.image"><img :src="answer.image" /></div>
                <div class="option-text">{{ getLocalizedAnswer(index, answer) }}</div>
              </div>
              <div
                class="option-item-status"
                :class="{
                  correct: correct[currentQuestionIndex] && correct[currentQuestionIndex].length && correct[currentQuestionIndex].includes(index),
                  incorrect: correct[currentQuestionIndex] && correct[currentQuestionIndex].length && !correct[currentQuestionIndex].includes(index),
                }"
                v-show="interacted !== null && interacted[currentQuestionIndex] && interacted[currentQuestionIndex].length && interacted[currentQuestionIndex][0] !== null && !isCategory">
                <transition name="fade" mode="out-in">
                  <i class="fas fa-check" v-if="correct[currentQuestionIndex] && correct[currentQuestionIndex].length && correct[currentQuestionIndex].includes(index)"></i>
                  <i class="fas fa-times" v-if="correct[currentQuestionIndex] && correct[currentQuestionIndex].length && !correct[currentQuestionIndex].includes(index)"></i>
                </transition>
                <input
                  :disabled="interacted && interacted.length && interacted[currentQuestionIndex].length != 0 && interacted[currentQuestionIndex][0] !== null"
                  style="visibility: visible"
                  :id="currentQuestionComputed.id + index + answer"
                  type="checkbox"
                  @change="toggleAnswer($event, index)" />
              </div>
            </label>
          </div>
        </transition>
        <div class="interactions-nav-container">
          <button class="interaction-send-btn btn-alt" @click="previousQuestion" :disabled="currentQuestionIndex == 0" v-if="questions.length > 1 && !isBusy"><i class="fas fa-chevron-left"></i></button>
          <button
            class="interaction-send-btn"
            style="margin: 0 auto"
            :disabled="interacted && interacted[currentQuestionIndex].length != 0 && interacted[currentQuestionIndex][0] !== null"
            @click.prevent="setAnswer"
            v-if="answers[currentQuestionIndex] && answers[currentQuestionIndex].length && answers[currentQuestionIndex][0] !== null && !finished && !isBusy">
            OK
          </button>
          <SpinnerButton
            class="btn-alt"
            style="min-width: 40px; padding: 10px; margin: 0 auto; z-index: 1"
            v-if="answers[currentQuestionIndex] && answers[currentQuestionIndex].length && answers[currentQuestionIndex][0] !== null && !finished && isBusy" />
          <button class="interaction-send-btn btn-alt" @click="nextQuestion" :disabled="questions.lenght == 1 || currentQuestionIndex == questions.length - 1" v-if="questions.length > 1 && !isBusy">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
        <transition appear name="categoryFade" mode="out-in">
          <div class="category-finish-panel" v-if="categoryQuizFinished">
            <img :src="categoryQuizFinishedImage" v-if="categoryQuizFinishedImage" />
            <div v-html="categoryQuizFinishedText"></div>
          </div>
        </transition>
      </div>
    </div>
    <transition appear name="delayed-opacity" mode="out-in" v-if="categoryOverride && categoryQuizFinished && categoryQuizFinishedText">
      <div class="category-finished-overlay-container">
        <div v-html="categoryQuizFinishedText"></div>
      </div>
    </transition>
    <transition appear name="delayed-opacity" mode="out-in" v-if="categoryOverride && categoryQuizFinished && categoryQuizFinishedImage">
      <div class="category-finished-overlay-container">
        <img :src="categoryQuizFinishedImage" @click="$router.push({ name: 'Home' })" />
      </div>
    </transition>
  </section>
</template>

<script>
import SpinnerButton from '@/components/ui/SpinnerButton.vue';

export default {
  name: 'ExternalQuiz',

  components: { SpinnerButton },

  props: {
    config: {
      type: Object,
    },
    resultsTitle: {
      type: String,
    },
    typeShowResults: {
      type: Boolean,
    },
    interacted: {
      type: Array,
    },
    correct: {
      type: Array,
    },
    scored: {
      type: Number,
    },
    isCategory: {
      type: Boolean,
      default: false,
    },
    categories: {
      type: Array,
    },
    categoryOverride: {
      type: Boolean,
      default: false,
    },
    localized: {
      default: null,
    },
  },

  data() {
    return {
      quizKey: this.$RNG.randomKey(),
      isBusy: false,
      // showQuiz: true,
      showQuestion: true,
      showResults: false,
      currentQuestion: {},
      currentQuestionIndex: 0,
      questions: [{ answers: [] }],
      answers: [],
      finished: false,
      score: null,
    };
  },

  computed: {
    jsonParsedLocalized() {
      if (!this.localized) return {};

      let parsedLocalized;
      try {
        parsedLocalized = JSON.parse(this.localized);
      } catch (e) {
        console.error('Error parsing localized content:', e);
      }
      return parsedLocalized;
    },

    localizedContent() {
      const currentLocale = this.$i18n.locale || 'pt';
      return this.jsonParsedLocalized[currentLocale] || this.jsonParsedLocalized['pt'] || {};
    },

    localizedQuestionPrompt() {
      if (!this.$store.state.template.multilanguagesConfig) {
        const originalQuestion = this.questions[this.currentQuestionIndex]?.question;
        return originalQuestion?.prompt || originalQuestion;
      }
      const questionData = this.localizedContent.questions?.[this.currentQuestionIndex];
      if (questionData) {
        return questionData.prompt || questionData.question;
      }

      const originalQuestion = this.questions[this.currentQuestionIndex]?.question;
      return originalQuestion?.prompt || originalQuestion;
    },

    currentQuestionComputed() {
      this.quizKey = this.$RNG.randomKey();
      return this.questions[this.currentQuestionIndex];
    },
    alradyInteracted() {
      return this.interacted && this.interacted.length === this.questions.length;
    },
    hasCorrect() {
      return this.correct && this.correct.length > 0;
    },
    categoryQuizFinished() {
      return this.typeShowResults && this.isCategory && (this.finished || (this.alradyInteracted && this.hasCorrect));
    },
    categoryQuizFinishedImage() {
      if (!this.categoryOverride && !this.isCategory) return '';
      else if (this.scored === null || this.scored === undefined) return '';
      else return this.categories[this.scored]?.image ?? '';
    },
    categoryQuizFinishedText() {
      if (!this.categoryOverride && !this.isCategory) return '';
      else if (this.scored === null || this.scored === undefined) return '';
      else return this.categories[this.scored]?.text ?? '';
    },
  },

  methods: {
    getLocalizedAnswer(answerIndex, answer) {
      if (!this.$store.state.template.multilanguagesConfig) {
        return typeof answer === 'object' ? answer.text : answer;
      }
      const questionData = this.localizedContent.questions?.[this.currentQuestionIndex];
      const localizedAnswer = questionData?.answers?.[answerIndex];

      if (localizedAnswer) {
        return typeof localizedAnswer === 'object' ? localizedAnswer.text : localizedAnswer;
      }

      // Fallback to original answer data
      return typeof answer === 'object' ? answer.text : answer;
    },
    hideQuiz() {
      this.$emit('hideQuiz');
    },
    beginQuiz(quizData) {
      this.questions = quizData.questions;
      this.finished = false;
      let marker = `${this.$store.state.user.id}-${quizData.id}`;

      if (this.$store.state.markers.answeredQuiz.includes(marker)) {
        // this.finished = true;
      }
      this.showResults = this.typeShowResults;
    },
    setAnswer() {
      this.isBusy = true;
      this.questions.map((question, index) => {
        if (!this.answers[index]) {
          if (this.interacted && this.interacted[index]) this.answers[index] = this.interacted[index];
          else this.answers[index] = [null];
        } else this.answers = this.answers.filter((answer) => answer);
      });
      const obj = {
        id: this.questions[0].id,
        answers: this.answers.map((a) => JSON.stringify(a)),
      };
      this.$emit('finished', obj);

      setTimeout(() => {
        this.isBusy = false;
        if (this.currentQuestionIndex == this.questions.length - 1) this.finished = true;
        else this.nextQuestion();
      }, 1500);
    },
    previousQuestion() {
      if (this.currentQuestionIndex == 0) return;
      this.currentQuestionIndex--;
      this.questions[this.currentQuestionIndex] = this.questions[this.currentQuestionIndex];
    },
    nextQuestion() {
      if (this.currentQuestionIndex == this.questions.length - 1) return;
      this.currentQuestionIndex++;
      this.questions[this.currentQuestionIndex] = this.questions[this.currentQuestionIndex];
    },
    setScore(score) {
      this.score = score;

      setTimeout(() => {
        this.showResults = this.typeShowResults;
      }, 300);
    },
    toggleAnswer(e, answerIndex, id) {
      // console.log('toggleAnswer', { e }, e.currentTarget.checked, answerIndex);
      if (this.finished) return;
      if (e.currentTarget.checked) {
        // console.log('add answer', answerIndex);
        if (!this.answers[this.currentQuestionIndex]) this.answers[this.currentQuestionIndex] = [];
        this.answers[this.currentQuestionIndex] = [...this.answers[this.currentQuestionIndex], answerIndex];
        if (this.answers[this.currentQuestionIndex].length > 1) this.answers[this.currentQuestionIndex] = this.answers[this.currentQuestionIndex].filter((a) => a || a == 0);
      } else {
        // console.log('remove answer', answerIndex);
        this.answers = this.answers.map((answer, i) => {
          if (i == this.currentQuestionIndex) answer = answer.filter((a) => a != answerIndex);
          return answer;
        });
      }
      this.questions[this.currentQuestionIndex].answers = this.questions[this.currentQuestionIndex].answers.map((answer, i) => {
        return answer;
      });
      // this.quizKey = this.$RNG.randomKey();

      const isSingleOption = this.currentQuestionComputed.question?.isSingleOption;
      if (isSingleOption) {
        this.answers[this.currentQuestionIndex] = [answerIndex];
      }
    },
  },

  beforeMount() {
    this.showResults = this.typeShowResults;
  },
};
</script>

<style scoped lang="scss">
.external-quiz-section {
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;

  .quiz-title {
    position: relative;
    margin: 0px auto 30px;
    padding: 5px 30px;
    width: auto;
    text-transform: uppercase;
    background: var(--live-bgColor);
    color: var(--live-textColor);
    box-shadow: 0 0 20px #000;
    border-radius: var(--input-borderRadius) var(--input-borderRadius) 0 0;
  }

  .question-container {
    position: relative;
    width: 100%;
    max-width: 1024px;
    border-radius: var(--input-borderRadius);
    border: 1px solid var(--quiz-outlineColor);
    background: var(--quiz-panelBgColor);
    overflow: hidden;
    @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
      background: var(--quiz-panelBgColor);
    }

    .quiz-options-and-nav {
      position: relative;
    }
  }

  .category-finish-panel {
    position: sticky;
    inset: 0;
    background: var(--quiz-panelBgColor);
    z-index: 1;
    min-height: 100%;
    flex-grow: 1;

    // display: flex;
    // justify-content: center;
    // align-items: center;

    aspect-ratio: 16/9;
    img {
      position: absolute;
      inset: 0 0 auto 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center;
    }

    div {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .question-text {
    position: relative;
    margin: 15px;
    padding: 8px;
    border-radius: var(--input-borderRadius);
    color: var(--quiz-questionColor);
    background: var(--quiz-questionBgColor);
    font-size: 1.2rem;
  }

  .options-container {
    position: relative;
    width: 100%;
    margin: 0;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }

  .option-item {
    cursor: pointer;
    position: relative;
    min-height: 40px;
    min-width: 40%;
    flex-grow: 1;
    margin: 6px;
    padding: 0 0 0 16px;

    background: var(--quiz-optionsBgColor);
    color: var(--quiz-optionsColor);
    border-radius: var(--input-borderRadius);

    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: stretch;
    align-items: stretch;

    &:active:not(.picked, .unpicked) {
      transform: scale(0.98);
      opacity: 0.8;
    }
    &:disabled {
      opacity: 0.3;
      cursor: auto;
    }
    &.unpicked {
      color: var(--quiz-optionsColor);
      background: var(--quiz-optionsBgColor);
    }
    &.picked {
      color: var(--quiz-pickedColor);
      background: var(--quiz-pickedBgColor);
    }
    .option-image-text {
      position: relative;
      flex-grow: 1;

      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: center;
      align-items: center;
    }
    .option-text {
      position: relative;
      padding: 10px 30px 10px 0;
      color: inherit;
      display: flex;
      align-items: center;
    }
    .option-image {
      position: relative;
      padding: 10px;
      width: 100%;
      display: flex;
      justify-content: center;
      img {
        max-height: 72px;
        object-fit: cover;
      }
    }

    .option-item-status {
      position: absolute;
      right: 0;
      min-width: 40px;
      min-height: 100%;

      display: flex;
      align-items: center;
      justify-content: center;

      &.correct {
        color: var(--quiz-correctColor);
        background: var(--quiz-correctBgColor);
        border-radius: 0 var(--input-borderRadius) var(--input-borderRadius) 0;
      }
      &.incorrect {
        // background: rgb(182, 0, 85);
        color: var(--quiz-incorrectColor);
        background: var(--quiz-incorrectBgColor);
        border-radius: 0 var(--input-borderRadius) var(--input-borderRadius) 0;
      }
      input {
        display: none;
      }
    }
  }
}
.interactions-nav-container {
  width: 100%;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .interaction-send-btn {
    cursor: pointer;
    position: relative;
    padding: 10px 18px;
    border: none;
    outline: none;
    color: var(--quiz-btnColor);
    background: var(--quiz-btnBgColor);
    border-radius: var(--input-borderRadius);

    &:disabled {
      opacity: 0.1;
    }
  }
}
.quiz-question-img-container {
  .quiz-question-img {
    width: 100%;
    height: auto;
    max-width: 100%;
    max-height: 306px;
    object-fit: contain;
    border-radius: var(--input-borderRadius) var(--input-borderRadius) 0 0;
  }
}
.category-finished-overlay-container {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: var(--main-color);

  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
